import { FC } from 'react';
import {
  ClearIndicatorProps,
  DropdownIndicatorProps,
  LoadingIndicatorProps,
  OptionProps,
  SingleValueProps,
  components,
} from 'react-select';

import { faChevronDown, faCircleNotch, faTimes } from '@fortawesome/pro-regular-svg-icons';

import ClickableIcon from '../ClickableIcon';
import Icon from '../Icon';
import Text from '../Text';

export const OptionWithSuffix = ({ label, suffix }: { label: string; suffix?: string }) => {
  return (
    <div className="next-to-spaced">
      <Text>{label}</Text>
      {suffix && (
        <Text type="helper" color="darkGrey">
          {suffix}
        </Text>
      )}
    </div>
  );
};

export const Option: FC<OptionProps<{ label: string; suffix?: string }>> = (optionProps) => {
  const { label, suffix } = optionProps.data;
  return (
    <components.Option {...optionProps}>
      <OptionWithSuffix label={label} suffix={suffix} />
    </components.Option>
  );
};

export const SingleValue: FC<SingleValueProps<{ label: string; suffix?: string }>> = (singleValueProps) => {
  const { label, suffix } = singleValueProps.data;

  return (
    <components.SingleValue {...singleValueProps}>
      <OptionWithSuffix label={label} suffix={suffix} />
    </components.SingleValue>
  );
};

export const DropdownIndicator: FC<DropdownIndicatorProps> = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon icon={faChevronDown} size={13} color="darkGrey" className="ml-5 mr-5" />
    </components.DropdownIndicator>
  );
};

export const ClearIndicator: FC<ClearIndicatorProps> = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <ClickableIcon icon={faTimes} size={15} />
    </components.ClearIndicator>
  );
};

export const LoadingIndicator: FC<LoadingIndicatorProps> = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <Icon icon={faCircleNotch} spin size={13} color="darkGrey" />
    </components.ClearIndicator>
  );
};
